import handler from '../handler/handler';
import messages from '../handler/messages/wine-messages';

const statusHandler = handler(messages);

export default {
  state: {
    curations: null,
  },
  getters: {
    getCurationList: state => state.curations,
  },
  mutations: {
    successCurations: (state, payload) => {
      state.curations = payload;
    },
  },
  actions: {
    orderUp: async ({ commit, getters }, index) => {
      const result = await statusHandler.authPut({ commit, getters }, `/api/curations/order/up/${index}`);
      return result;
    },

    orderDown: async ({ commit, getters }, index) => {
      const result = await statusHandler.authPut({ commit, getters }, `/api/curations/order/down/${index}`);
      return result;
    },

    updateCuration: async ({ commit, getters }, data) => {
      const curation = {
        id: data.id,

        title: data.title,

        img_top: data.imgTop,

        is_auto_start: data.isAutoStart,
        begin_at: data.beginAt,
        expire_at: data.expireAt,

        type: data.type,
        link: data.link,
        alignment: data.alignment,

        wines_in_curation: data.winesInCuration,

        is_enabled: data.isEnabled,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/curations/${curation.id}`, curation);
      return result;
    },

    createEmptyCuration: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/curations/');
      return result;
    },

    deleteCuration: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/curations/${id}`);
      return result;
    },

    deleteCurations: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/curations/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/curation.js